import { myAxios } from "./axios"

export function getContacts(data, { page, perPage }) {
    let config = {
        params: {
            page,
            perPage,
            ...(data || {})

        },
    }
    return myAxios.get("/company-contacts", config)
}

export function searchAndExport(data) {
    let config = {
        params: {
            filter: data
        },
    }
    return myAxios.get("/company-contacts/export", config)
}

export function getContact(id) {
    return myAxios.get("/company-contacts/" + id)
}

export function addContact(data) {
    return myAxios.post("/company-contacts/create", data)
}

export function editContact(id, data) {
    return myAxios.put("/company-contacts/" + id + "/update", data)
}

export function deleteContact(id) {
    return myAxios.delete("/company-contacts/" + id + "/delete")
}

export function importFile(data) {
    return myAxios.post("/company-contacts/import", data)
}